<template>
  <div class="vmp-video-preview">
    <div
      class="vmp-video-preview-wrap"
      v-loading="loading"
      :element-loading-text="$t('common.common_1001')"
      element-loading-background="rgba(0,0,0,.9)"
      @mousemove="wrapEnter"
      @mouseleave="wrapLeave(true)"
    >
      <div
        :id="'videoDom' + timestamp"
        class="vmp-video-preview-wrap-container"
        :class="isAudio && isInsertVideoPreview ? 'vmp-video-preview-wrap-container__hide' : ''"
      >
        <div class="vmp-video-preview-wrap-tips" v-if="isAudio && !isInsertVideoPreview">
          <div class="vmp-video-img">
            <img class="audio-img" :src="audioImg" alt="" />
          </div>
        </div>
        <div
          class="vmp-video-preview-wrap-controller"
          :class="hoveVideo ? 'vmp-video-preview-wrap-controller__active' : ''"
          v-show="isShowController"
        >
          <div class="vmp-video-preview-wrap-controller-slider" v-show="isVod">
            <!-- 进度条 -->
            <vh-slider
              v-model="sliderVal"
              :show-tooltip="false"
              ref="controllerRef"
              @change="setVideo"
            ></vh-slider>
            <div
              v-show="isVod"
              :style="{ left: hoverLeft + 'px' }"
              class="vmp-video-preview-wrap-controller-times"
            >
              <span>{{ hoverTime | secondToDate }}</span>
            </div>
          </div>
          <div class="vmp-video-preview-wrap-controller-icons">
            <div class="vmp-video-preview-wrap-controller-icons-left">
              <i
                class="vh-iconfont"
                :class="statePaly ? 'vh-a-line-videopause' : 'vh-line-video-play'"
                @click="videoPlayBtn"
              ></i>
              <div class="vmp-center-box" :class="isVod ? '' : 'vmp-center-box__hidden'">
                <template v-if="totalTime > 0">
                  <span>
                    {{ currentTime | secondToDate }}
                  </span>
                  <span>/</span>
                  <span>{{ totalTime | secondToDate }}</span>
                </template>
                <template v-else>
                  <span>--:--/--:--</span>
                </template>
              </div>
            </div>
            <div class="vmp-video-preview-wrap-controller-icons-right">
              <div class="vmp-volume-box">
                <span class="vmp-icon-box">
                  <i
                    class="vh-iconfont"
                    @click="jingYin"
                    :class="voice > 0 ? 'vh-line-voice' : 'vh-line-mute'"
                  ></i>
                </span>
                <div class="vmp-ver-slider">
                  <vh-slider
                    vertical
                    height="100px"
                    :min="0"
                    @change="setVoice"
                    v-model="voice"
                  ></vh-slider>
                </div>
              </div>
              <template v-if="!isInsertVideoPreview">
                <i
                  v-if="isFullscreen"
                  class="vh-iconfont vh-a-line-exitfullscreen"
                  @click="exitFullscreen"
                ></i>
                <i v-else class="vh-iconfont vh-a-line-fullscreen" @click="enterFullscreen"></i>
              </template>
              <!-- 插播视频播放器显示的按钮 -->
              <template v-if="isInsertVideoPreview">
                <vh-dropdown @command="handleCommand" placement="top" trigger="click">
                  <span class="vh-dropdown-link">
                    <vh-tooltip class="item" effect="dark" :content="$t('host.k_666001')">
                      <span
                        v-show="curInsertVideoType == 1"
                        class="iconfont-v3 saasline-video"
                      ></span>
                    </vh-tooltip>
                    <vh-tooltip class="item" effect="dark" :content="$t('host.k_666002')">
                      <span
                        v-show="curInsertVideoType == 2"
                        class="iconfont-v3 saasa-line-radiolist"
                      ></span>
                    </vh-tooltip>
                    <vh-tooltip class="item" effect="dark" :content="$t('host.k_666003')">
                      <span
                        v-show="curInsertVideoType == 3"
                        class="iconfont-v3 saasa-line-playcycle"
                      ></span>
                    </vh-tooltip>
                  </span>
                  <vh-dropdown-menu slot="dropdown" class="dropdownVideo insertDropdownVideo">
                    <vh-dropdown-item :command="1">
                      <span class="iconfont-v3 saasline-video"></span>
                      {{ $t('host.k_666001') }}
                    </vh-dropdown-item>
                    <vh-dropdown-item :command="2">
                      <span class="iconfont-v3 saasa-line-radiolist"></span>
                      {{ $t('host.k_666002') }}
                    </vh-dropdown-item>
                    <vh-dropdown-item :command="3">
                      <span class="iconfont-v3 saasa-line-playcycle"></span>
                      {{ $t('host.k_666003') }}
                    </vh-dropdown-item>
                  </vh-dropdown-menu>
                </vh-dropdown>

                <vh-tooltip effect="dark" :content="$t('host.k_666004')">
                  <i @click="$emit('openInsert')" class="vh-iconfont vh-line-menu"></i>
                </vh-tooltip>
                <vh-tooltip effect="dark" :content="$t('host.k_666005')">
                  <i
                    @click="$emit('closeInsertvideo', { isShowConfirmDialog: true })"
                    class="vh-iconfont vh-line-close"
                  ></i>
                </vh-tooltip>
                <vh-tooltip effect="dark" :content="$t('host.k_666006')">
                  <i @click="hideInsertVideoControl" class="vh-iconfont vh-line-arrow-down"></i>
                </vh-tooltip>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { useRoomBaseServer, usePlayerServer } from 'middle-domain';
  import { throttle } from 'lodash';
  export default {
    name: 'VmpVideoPreview',
    props: {
      videoParam: {
        type: Object,
        required: true
      },
      // 是否显示控制栏
      isShowController: {
        type: Boolean,
        require: false,
        default: false
      },
      isInsertVideoPreview: {
        type: Boolean,
        default: false,
        required: false
      },
      scene: {
        type: String,
        default: ''
      },
      insertPlayType: {
        type: Number,
        default: 1
      },
      curInsertParams: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        roomBaseState: null,
        totalTime: 0,
        currentTime: 0,
        statePaly: false, // 播放状态
        voice: 20, // 音量
        isMute: false, // 是否为静音
        sliderVal: 0,
        hoverTime: 10, // seek显示时间
        hoverLeft: 10,
        TimesShow: false,
        loading: true,
        hoveVideo: false,
        isFullscreen: false,
        tipsType: 0, // 1为音频封面   2 播放结束
        audioImg: require('./images/video.gif'),
        timestamp: '', // 播放器容器时间戳
        curInsertVideoType: 1
      };
    },
    watch: {
      insertPlayType: {
        handler: function (val) {
          this.curInsertVideoType = parseInt(val + '');
        },
        immediate: true
      },
      curInsertParams: {
        handler: function (val) {
          this.sliderVal = val?.sliderVal || 0;
        },
        immediate: true,
        deep: true
      },
      curInsertVideoType: {
        handler: function (val) {
          this.$emit('changeInsertVideoType', this.curInsertVideoType);
        },
        immediate: true
      }
    },
    computed: {
      isAudio() {
        if (this.videoParam.isAudio) return true;
        const videoType = this.videoParam.file_type;
        if (!videoType) return false;
        return videoType.toLowerCase() == '.mp3' || videoType.toLowerCase() == '.mav';
      },
      isVod() {
        return this.videoParam.type == 'vod' || !this.videoParam.type;
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
    },
    created() {
      this.roomBaseState = this.roomBaseServer.state;
      this.playerServer = usePlayerServer({
        extra: true
      });
      this.timestamp = new Date().getTime();
      this.initPlayer();
    },
    methods: {
      initPlayer() {
        this.initSDK().then(async () => {
          if (this.isInsertVideoPreview) {
            this._firstInit = true;
          }
          console.log('初始化播放器成功');
          this.totalTime =
            this.playerServer.getDuration(() => {
              console.log('获取总时间失败');
            }) || 0; // 获取视频总时长
          this.initSlider(); // 初始化播放进度条
          this.listen();
          await this.$nextTick(0);
          if (this.curInsertParams) {
            try {
              this.setVideo();
            } catch (err) {
              console.error('插播断点续播');
            }
          } else {
            try {
              this.videoParam.autoplay && this.playerServer.play(); // TODO: player sdk 2.3.9+ 如果首次拉流404，后续不会自动播放，先hack解决
            } catch (err) {
              console.error('自动播放失败');
            }
          }
        });
      },
      async initSDK() {
        const { interact, join_info } = this.roomBaseState.watchInitData;
        const { videoParam } = this;
        let params = {
          appId: interact.paas_app_id || '', // 应用ID，必填
          accountId: join_info.third_party_user_id || '', // 第三方用户ID，必填
          token: interact.paas_access_token || '', // access_token，必填
          type: videoParam.type || 'vod', // live 直播  vod 点播  必填
          videoNode: 'videoDom' + this.timestamp, // 播放器的容器， div的id 必填
          poster: '', // 封面地址  仅支持.jpg
          autoplay: videoParam.autoplay || false,
          forceMSE: false,

          subtitleOption: {
            enable: true
          }
        };

        if (params.type === 'live') {
          Object.assign(params, {
            liveOption: videoParam.liveOption
          });
        }

        if (params.type === 'vod') {
          Object.assign(params, {
            vodOption: { recordId: videoParam.paas_record_id, forceMSE: false }
          });
        }

        console.log('video init params', params);
        return new Promise(resolve => {
          this.playerServer.init(params).then(() => {
            this.playerServer.openControls(false);
            this.playerServer.openUI(false);
            this.playerServer.$on('loadeddata_ext', () => {
              this.loading = false;
              resolve();
            });
          });
        });
      },
      videoPlayBtn() {
        this.statePaly ? this.playerServer.pause() : this.playerServer.play();
        if (this.isInsertVideoPreview) {
          window.vhallReportForProduct.toReport(110212, {
            report_extra: {
              type: 'yunInsert',
              file_info: '',
              pre_status: this.statePaly ? 'playing' : 'pause',
              after_atatus: this.statePaly ? 'pause' : 'playing'
            }
          });
        }
      },
      setVideo() {
        const time = (this.sliderVal / 100) * this.totalTime; // 快进
        this.setVideoCurrentTime(time);

        this.playerServer.play();
      },
      initSlider() {
        this.playerServer.$on('timeupdate', () => {
          this.currentTime = this.playerServer.getCurrentTime(() => {});
          this.sliderVal = (this.currentTime / this.totalTime) * 100;
          let _this = this;
          const { watchInitData } = useRoomBaseServer().state;
          if (watchInitData.webinar.type == 1) {
            //直播中
            this.saveCache(_this, watchInitData.webinar.id);
          }
        });
        // 拖拽显示时间
        const dom = this.$refs.controllerRef.$el;
        console.log('绑定事件dom', dom);
        const but = document.querySelector(
          '.vmp-video-preview-wrap-controller-slider .vh-slider__button-wrapper'
        );
        const innitDom = () => {
          dom.onmouseover = e => {
            console.log('dom over', e);
            if (
              e.target.className === 'vh-slider__button-wrapper' ||
              event.target.className.indexOf('vh-slider__button') > -1
            ) {
              this.TimesShow = false;
              return;
            }
            this.TimesShow = true;
            const totalWidth = dom.offsetWidth;
            this.ContorlWidth = dom.offsetWidth;
            const lef = e.layerX;
            this.hoverTime = (lef / totalWidth) * this.totalTime;
            if (lef < 16) {
              this.hoverLeft = 16;
            } else if (lef > 600) {
              this.hoverLeft = 600;
            } else {
              this.hoverLeft = lef;
            }

            dom.onmousemove = event => {
              // console.log('----dingxiaodong----mousemove', event);
              if (
                event.target.className === 'vh-slider__button-wrapper' ||
                event.target.className.indexOf('vh-slider__button') > -1
              ) {
                this.TimesShow = false;
                return;
              }
              const lef = event.layerX;
              this.hoverTime = (lef / totalWidth) * this.totalTime;
              if (lef < 16) {
                this.hoverLeft = 16;
              } else if (lef > 600) {
                this.hoverLeft = 600;
              } else {
                this.hoverLeft = lef;
              }
            };
          };
          dom.onmouseout = () => {
            this.TimesShow = false;
          };
        };
        innitDom();
        but.onmousedown = () => {
          dom.onmouseout = dom.onmousemove = dom.onmousemove = dom.onmouseover = null;
          this.ContorlWidth = dom.offsetWidth;
          this.onmousedownControl = true;
          this.playerServer.pause();
          document.onmousemove = () => {
            this.TimesShow = true;
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            this.onmousedownControl = false;
            this.TimesShow = false;
            innitDom();
          };
        };
        but.onmouseover = e => {
          this.TimesShow = false;
          e.stopPropagation();
        };
      },
      saveCache: throttle(
        function (_this, webinar_id) {
          if (_this.scene == 'insert') {
            //插播文件存储
            let arr = [];
            let inserts = sessionStorage.getItem('insertCache');
            if (inserts) {
              arr = JSON.parse(inserts);
              let flag = false;
              for (let i = 0; i < arr.length; i++) {
                const element = arr[i];
                if (
                  element.webinar_id == webinar_id &&
                  element.paas_record_id == _this.videoParam.paas_record_id
                ) {
                  flag = true;
                  arr[i] = {
                    webinar_id: webinar_id,
                    currentTime: _this.currentTime,
                    sliderVal: _this.sliderVal,
                    ..._this.videoParam
                  };
                } else if (
                  element.webinar_id == webinar_id &&
                  element.paas_record_id != _this.videoParam.paas_record_id
                ) {
                  arr.splice(i, 1);
                }
              }
              if (!flag) {
                arr.push({
                  webinar_id: webinar_id,
                  currentTime: _this.currentTime,
                  sliderVal: _this.sliderVal,
                  ..._this.videoParam
                });
              }
            } else {
              arr.push({
                webinar_id: webinar_id,
                currentTime: _this.currentTime,
                sliderVal: _this.sliderVal,
                ..._this.videoParam
              });
            }
            const { watchInitData } = useRoomBaseServer().state;
            if (watchInitData.webinar.type == 1) {
              sessionStorage.setItem('insertCache', JSON.stringify(arr));
            }
          }
        },
        3000,
        { trailing: false }
      ),
      jingYin() {
        if (this.isMute) {
          this.voice = this._cacheVolume;
          this.isMute = false;
          this.playerServer.setVolume(this.voice);
        } else {
          this._cacheVolume = this.voice;
          this.voice = 1;
          this.isMute = true;
          this.playerServer.setVolume(this.voice);
        }
      },
      setVoice() {
        this.playerServer.setVolume(this.voice);
      },
      enterFullscreen() {
        this.isFullscreen = true;
        this.playerServer.enterFullScreen();
      },
      exitFullscreen() {
        this.isFullscreen = false;
        this.playerServer.exitFullScreen();
      },
      destroy() {
        console.log('销毁点播播放器');
        this.playerServer.destroy();
      },
      // 设置播放时间
      setVideoCurrentTime(val) {
        if (!this.playerServer) return;

        this.playerServer.setCurrentTime(val, () => {
          this.$message({
            type: 'error',
            message: this.$t('host.k_666007')
          });
          console.error('设置当前播放时间失败');
        });
      },
      listen() {
        this.playerServer.$on('ended', () => {
          console.log('播放结束', this.curInsertVideoType);
          this.tipsType = 2;
          if (this.isInsertVideoPreview) {
            this._isVideoEnd = true;
            this.tipsType = 0;
            this.$emit('insertVideoEnd', this.curInsertVideoType);
            if (this.curInsertVideoType == 3) {
              //单视频循环播放
              this.videoPlayBtn();
            }
          }
        });
        this.playerServer.$on('play_ext', () => {
          console.log('播放器播放事件');
          this.statePaly = true;
          // 监听播放状态
          if (this.isInsertVideoPreview) {
            if (!this._firstInit) {
              this.$emit('handleRemoteInsertVideoPlay', this._isVideoEnd);
            }
            this._isVideoEnd = false;
            if (this._firstInit) {
              const elVideo = document.querySelector(`#videoDom${this.timestamp} video`);
              this.$emit('remoteInsertSuccess', elVideo);
              this._firstInit = false;
            }
          }
        });
        this.playerServer.$on('pause', () => {
          console.log('视频预览播放器暂停');
          if (this.isInsertVideoPreview) {
            // 监听暂停状态
            this.$emit('handleRemoteInsertVideoPause');
          }
          this.statePaly = false;
        });
        /**
         *  监听退出全屏事件
         */
        window.addEventListener(
          'fullscreenchange',
          () => {
            if (document.fullscreenElement) {
              // 进入全屏
            } else {
              // 离开全屏
              this.isFullscreen = false;
            }
          },
          true
        );
      },
      // 隐藏播放器控制栏
      hideInsertVideoControl() {
        this.hoveVideo = false;
      },
      wrapEnter() {
        this.hoveVideo = true;
      },
      wrapLeave(isSelfInvok) {
        // 如果是插播播放器，禁止组件自身触发leave方法，只能通过 parent.refs 调用
        if (isSelfInvok && this.isInsertVideoPreview) {
          return;
        }
        this.hoveVideo = false;
      },
      handleCommand(command) {
        this.curInsertVideoType = command;
      }
    },
    beforeDestroy() {
      if (this.playerServer) {
        this.playerServer.destroy();
      }
    }
  };
</script>
<style lang="less">
  .vmp-video-preview {
    width: 100%;
    height: 100%;
    &-wrap {
      height: 100%;
      position: relative;
      overflow: hidden;
      &-container {
        height: 100%;
        width: 100%;
        background: black;
        &__hide {
          background: rgba(0, 0, 0, 0);
          /deep/ video {
            visibility: hidden;
          }
        }
      }
      &-tips {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #000;
        .vmp-video-img {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          .audio-img {
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
        }
      }
      &-controller {
        position: absolute;
        z-index: 6;
        width: 100%;
        height: 40px;
        bottom: -31px;
        background: rgba(0, 0, 0, 0.7);
        transition: all 0.8s;
        color: white;
        &__active {
          bottom: 0;
        }
        &-slider {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          &:hover {
            // top: -2px;
            .vh-slider__runway {
              height: 3px;
            }
            .vh-slider__bar {
              height: 3px;
            }
            .vmp-video-preview-wrap-controller-times {
              display: block;
            }
          }
          .vh-slider {
            .vh-slider__runway {
              margin: 0;
              height: 3px;
              background-color: rgba(255, 255, 255, 0.3);
            }
          }
          .vh-slider__button-wrapper {
            top: -16px;
          }
          .vh-slider__bar {
            height: 3px;
            background-color: #fb3a32;
          }
          .vh-slider__button {
            width: 10px;
            height: 10px;
            border-color: #fb3a32;
          }
        }
        &-times {
          position: absolute;
          line-height: 14px;
          top: -35px;
          text-align: center;
          padding: 5px;
          background: rgba(0, 0, 0, 0.3);
          font-size: 12px;
          color: #fff;
          transform: translateX(-50%);
          display: none;
        }
        &-icons {
          width: 100%;
          display: flex;
          justify-content: space-between;
          &-left {
            i:first-child {
              padding: 0 8px;
              cursor: pointer;
            }
            .local-icon {
              margin: 0 4px;
            }
            .vmp-center-box {
              display: inline-block;
              line-height: 48px;
              &__hidden {
                visibility: hidden;
              }
            }
          }
          &-right {
            i:last-child {
              padding: 0 12px;
              cursor: pointer;
            }
            .vmp-volume-box {
              display: inline-block;
              line-height: 34px;
              position: relative;
              height: 34px;
              margin-top: 6px;
              &:hover {
                .vmp-ver-slider {
                  display: block;
                }
              }
              .vmp-icon-box {
                i {
                  padding-right: 5px;
                  cursor: pointer;
                }
              }
              .vmp-ver-slider {
                display: none;
                position: absolute;
                left: 16px;
                bottom: 32px;
                .vh-slider {
                  .vh-slider__runway {
                    margin: 0;
                    height: 3px;
                    background-color: rgba(255, 255, 255, 0.3);
                  }
                }
                .vh-slider__bar {
                  height: 3px;
                  background-color: #fb3a32;
                }
                .vh-slider__button {
                  width: 10px;
                  height: 10px;
                  border-color: #fb3a32;
                }
              }
            }
            .vh-dropdown-link,
            .vh-line-menu,
            .vh-line-close {
              margin-left: 12px;
            }
            .vh-iconfont,
            .iconfont-v3 {
              cursor: pointer;
              &:hover {
                color: #fb3a32;
              }
            }
            .iconfont-v3 {
              font-size: 18px;
            }
            .vh-dropdown {
              color: #fff;
            }
          }
        }
      }
    }
    .vhallPlayer-container {
      display: none !important;
    }
  }
  .dropdownVideo {
    background-color: rgba(0, 0, 0, 0.7) !important;
    .vh-dropdown-menu__item {
      color: #fff;
      &:not(.is-disabled):hover {
        color: var(--theme-color-main);
        background: transparent;
      }
    }
  }
  .insertDropdownVideo {
    .vh-dropdown-menu__item {
      font-size: 12px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      span {
        margin-right: 4px;
      }
    }
  }
</style>
